var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ACCOUNT_CHECKOUT, ACCOUNT } from "@/stores/defs";
import { mapActions, mapGetters } from "vuex";
import { EPreorder } from "@/services/order.service";
import { find } from 'lodash';
var paymentMixin = {
    computed: __assign({}, mapGetters({
        paymentMethod: ACCOUNT_CHECKOUT.GET_PAYMENT_METHOD,
        getSelectedPaymentId: ACCOUNT.GET_SELECTED_PAYMENT,
        preorder: ACCOUNT_CHECKOUT.GET_PREORDER,
        customer: ACCOUNT.GET_CUSTOMER,
    }), { isPayNow: function () {
            var preorder = this.preorder;
            return (preorder === EPreorder.PAY_NOW);
        },
        isPayLater: function () {
            var preorder = this.preorder;
            return (preorder === EPreorder.PAY_LATER);
        },
        displayPaymentMethod: function () {
            var preorder = this.preorder;
            if (preorder === EPreorder.PAY_LATER) {
                return 'Pay in person';
            }
            if (!this.getSelectedPaymentId) {
                return 'Select payment';
            }
            var paymentAccounts = this.getPaymentAccounts();
            var selectedPayment = this.getSelectedPaymentAccount();
            if (!paymentAccounts || !selectedPayment) {
                return 'Add payment';
            }
            var paymentName = this._getPaymentNameWithMask(selectedPayment);
            return "" + paymentName;
        },
        _paymentSelected: function () {
            return this.getSelectedPaymentId;
        },
        _noPaymentSelected: function () {
            return !this._paymentSelected;
        },
        _validPayment: function () {
            var selectedId = this._paymentSelected;
            var selectedPayment = this.getSelectedPaymentAccount();
            return (selectedId && selectedPayment);
        } }),
    methods: __assign({}, mapActions({
        setPreorder: ACCOUNT_CHECKOUT.SET_PREORDER,
        setSelectedPaymentId: ACCOUNT.SET_SELECTED_PAYMENT,
        setPaymentMethod: ACCOUNT_CHECKOUT.SET_PAYMENT_METHOD,
    }), { getPaymentAccounts: function () {
            var customer = this.customer;
            if (!customer) {
                console.warn('no customer set for payment accounts');
                return null;
            }
            var paymentAccounts = customer.paymentAccounts;
            return paymentAccounts;
        },
        getSelectedPaymentAccount: function () {
            var paymentAccounts = this.getPaymentAccounts();
            if (!paymentAccounts) {
                return null;
            }
            var selectedId = this.getSelectedPaymentId;
            var paymentAccount = find(paymentAccounts, function (account) {
                return account.id === selectedId;
            });
            return paymentAccount;
        },
        _getPaymentNameWithMask: function (paymentAccount, active) {
            if (active === void 0) { active = false; }
            var cardType = paymentAccount.logo;
            var account = paymentAccount.accountNumber;
            var label = (active) ? 'Pay with ' : '';
            return "" + label + cardType + " *" + account;
        },
        setDefaultPaymentMethod: function () {
            if (this.preorder) {
                return;
            }
            var $appConstants = this.$appConstants;
            var payment = $appConstants.payment;
            this.setPreorder(+payment.defaultMethod);
            return;
        } }),
};
export default paymentMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/paymentMixin.ts
// module id = 9tqk
// module chunks = 18